import React from "react";
import { useNavigate,Link } from "react-router-dom";
import Button from "../../../components/ui/Button";

const HeroActions = () => {
  const navigate = useNavigate();

  const handleViewWork = () => {
    navigate("/project-showcase-gallery");
  };

  // const handleConnect = () => {
  //   // Smooth scroll to contact section or navigate to contact page
  //   const contactSection = document.getElementById("contact");
  //   if (contactSection) {
  //     contactSection?.scrollIntoView({ behavior: "smooth" });
  //   } else {
  //     // If no contact section on current page, could navigate to contact page
  //     window.scrollTo({ top: document.body?.scrollHeight, behavior: "smooth" });
  //   }
  // };

  // const handleDownloadResume = () => {
  //   // Mock resume download
  //   const link = document.createElement('a');
  //   link.href = '#';
  //   link.download = 'Yash_Pal_Resume.pdf';
  //   link?.click();
  // };

  return (
    <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
      {/* Primary CTA */}
      <Button
        variant="default"
        size="lg"
        className="bg-cta hover:bg-cta/90 text-white font-semibold px-8 py-3 min-w-[160px]"
        iconName="ExternalLink"
        iconPosition="right"
        iconSize={18}
        onClick={handleViewWork}
      >
        View My Work
      </Button>

      {/* Secondary CTA */}
      <Link to="/contact">
        <Button
          variant="outline"
          size="lg"
          className="border-conversion-accent text-conversion-accent hover:bg-conversion-accent hover:text-background font-semibold px-8 py-3 min-w-[160px]"
          iconName="MessageCircle"
          iconPosition="left"
          iconSize={18}
          // onClick={handleConnect}
        >
          Let's Connect
        </Button>
      </Link>

      {/* Tertiary Action */}
      <Button
        variant="ghost"
        size="lg"
        className="text-muted-foreground hover:text-foreground font-medium px-6 py-3"
        iconName="Download"
        iconPosition="left"
        iconSize={16}
        // onClick={handleDownloadResume}
      >
        Resume
      </Button>
    </div>
  );
};

export default HeroActions;
